export const currencyUploadStoreKey = 'currencyUpload';
